import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tax-tariff-tranche.reducer';

export const TaxTariffTrancheDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const taxTariffTrancheEntity = useAppSelector(state => state.taxTariffTranche.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="taxTariffTrancheDetailsHeading">
          <Translate contentKey="crawlerBackendApp.taxTariffTranche.detail.title">TaxTariffTranche</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="crawlerBackendApp.taxTariffTranche.type">Type</Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheEntity.type}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.taxTariffTranche.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheEntity.productType}</dd>
          <dt>
            <span id="trancheLowerBound">
              <Translate contentKey="crawlerBackendApp.taxTariffTranche.trancheLowerBound">
                Tranche Lower Bound
              </Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheEntity.trancheLowerBound}</dd>
          <dt>
            <span id="trancheUpperBound">
              <Translate contentKey="crawlerBackendApp.taxTariffTranche.trancheUpperBound">
                Tranche Upper Bound
              </Translate>
            </span>
          </dt>
          <dd>{taxTariffTrancheEntity.trancheUpperBound}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.taxTariffTranche.productOfferingPrice">
              Product Offering Price
            </Translate>
          </dt>
          <dd>
            {taxTariffTrancheEntity.productOfferingPrices
              ? taxTariffTrancheEntity.productOfferingPrices.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {taxTariffTrancheEntity.productOfferingPrices &&
                    i === taxTariffTrancheEntity.productOfferingPrices.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/tax-tariff-tranche" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tax-tariff-tranche/${taxTariffTrancheEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TaxTariffTrancheDetail;
